module.exports = __webpack_public_path__ + "static/media/orange_slippers.c1f9f38b.jpg";